import Form from 'react-bootstrap/Form';

function InputSwitch(props: any) {
  let nameComponent = props.nameComponent ?? "";
  let checked = props.checked ?? false;
  let disabled = props.disabled ?? false;
  let label = props.label ?? "";

  const onChange = (input: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(input.target.checked)
    }
  }

  return (
    <Form.Check
      type="switch"
      id={nameComponent}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      label={label}
    />
  )
}

export default InputSwitch;